import { createContext, useState } from 'react'

export const useTitle = () => {
  const [title, setTitle] = useState('')

  const setCurrentTitle = (title: string) => {
    setTitle(title)
  }

  return {
    title,
    setCurrentTitle
  }
}

export const TitleContext = createContext<string | null>(null)
